import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchMatchDetailsApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_MATCH_DETAILS_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerFetchMatchDetailsApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const TXN_ID = data?.['txnId'];
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE,
		url: API_CONSTANT.URL.SCRATCH_CARD.T20.GET_MATCH_DETAILS + API_CONSTANT.QUERY_PARAMS.TXN_ID + TXN_ID,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		callback && callback(apiData);
		yield put(triggerFetchMatchDetailsApiCallSuccess(apiData));
	}
}

export default function* triggerFetchMatchDetailsApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_MATCH_DETAILS_API, triggerFetchMatchDetailsApiCall);
}
